import React from 'react';

type Variant = 'normal' | 'warning' | 'critical';

type SemiDonutProps = {
  percentage: number; // 0–100
  variant?: Variant;
  size?: number;
  strokeWidth?: number;
};

const VARIANT_COLORS: Record<Variant, string> = {
  normal: '#1aad7f',
  warning: '#e88f25',
  critical: '#ff0700',
};

export const SemiDonut = ({
  percentage,
  variant = 'normal',
  size = 24,
  strokeWidth = 3,
}: SemiDonutProps) => {
  const clamped = Math.max(0, Math.min(100, percentage));
  const color = VARIANT_COLORS[variant];

  const targetOffset = 100 - clamped;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M21.6667 16.3333C21.6667 11.1787 17.488 7 12.3333 7C7.17868 7 3 11.1787 3 16.3333"
        stroke="#E5E5E5"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />

      <path
        key={percentage}
        className="progress"
        d="M21.6667 16.3333C21.6667 11.1787 17.488 7 12.3333 7C7.17868 7 3 11.1787 3 16.3333"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        pathLength={100}
        strokeDasharray="100"
        style={
          {
            '--target-offset': targetOffset,
          } as React.CSSProperties
        }
      />
    </svg>
  );
};
